import React from 'react';
import PropTypes from 'prop-types';

const ProductPageSectionTitle = ({
  className = '',
  children,
  ...otherProps
}) => (
  <h2
    {...otherProps}
    className={`text-3xl font-bold text-gray lg:mb-[.6rem] ${className}`}
  >
    {children}
  </h2>
);

ProductPageSectionTitle.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default ProductPageSectionTitle;
